import {Injectable, OnDestroy} from '@angular/core';
import {SaleProductModel} from "../entity/saleProduct.model";
import {SaleProductSummaryModel} from "../entity/saleProductSummary.model";
import {SaleProductRepository} from "../../impl/service/ngrx/SaleProduct.repository";
import {SaleProductSummaryDataServiceAdapter} from "../../impl/service/ngrx/SaleProductSummaryDataService.adapter";
import {AbstractFindAllService} from "../../../../../core/service/v2/service/findAll/abstractFindAll.service";

@Injectable()
export class SaleProductSummaryFindAllService extends AbstractFindAllService<SaleProductModel, SaleProductSummaryModel> implements OnDestroy {
    constructor(repository: SaleProductRepository, serviceAdapter: SaleProductSummaryDataServiceAdapter) {
        super(repository, serviceAdapter);
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}
